export class Unidad {
    idUnidad: number;
    tipoUnidad: string;
    ded: string;
    deducible: number;
    demerito: number;
    economico: string;
    kmEntrada: number;
    kmSalida: number;
    poliza: string;
    placa: string;
    modelo: string;
    reporte: string;
    serie: string;
    gasolina: number;
    gasPorcentaje = 0;
    cabinaDerecha: number;
    cabinaFrontal: number;
    cabinaIzquierda: number;
    cabinaTrasera: number;
    cajaDerecha: number;
    cajaFrontal: number;
    cajaIzquierda: number;
    cajaTrasera: number;
    fechaPromesa: Date;
    idMarca: number;
    idVolante: number;
    idTarjeta: number;
    idFactura: number;
    idFirma: number;
    comentario: string;
    observacionesInventario: string;
    valorComercial: number;
}

export class LlantaUnidad {
    idLlantaUnidad: number;
    idOrdenServicio: number;
    llanta: number;
    comentario: string;
}

export class EstadoUnidad {
    idOrdenServicio: number;
    posicion: string;
    valor: number;
}

export class CostoContable {
  idOrdenServicio: number;
  costoManoObra: number;
  costoRefacciones: number;
  idEmpleado: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/unidad.ts